import React from "react";
import { AnimationsEnum, AnimatedWrapper } from "@/components/AnimatedWrapper";
import CodeSnippet from "@/components/CodeSnippet";
import type { AllowedApis } from "@/components/CodeSnippet";

export default function ProductAPIIntegrationSection({
  description,
  title,
  highlight,
  path,
}: {
  description: string;
  title: string;
  highlight: string;
  path: string;
}) {
  const [before, after] = title.split(highlight);

  return (
    <section className="flex flex-col gap-10">
      <div className="flex justify-center items-center flex-col lg:flex-row gap-4">
        <div className="flex gap-4 flex-col items-start md:items-center justify-center w-full md:w-4/5">
          <p className="flex items-center justify-center">
            <span className="bg-[#E7D7FD] rounded-full px-3 py-1 text-[#8937F4] inline-block font-semibold">
              API INTEGRATIONS
            </span>
          </p>
          <div className="flex flex-col gap-4">
            <span className="md:text-[45px] text-2xl text-secondary-900 font-bold md:text-center leading-tight">
              {before}
              <span className="bg-gradient-to-r from-[#4337cc] to-primary-900 bg-clip-text text-transparent">
                {highlight}
              </span>{" "}
              {after}
            </span>
            <span className="md:text-center md:text-xl text-base">
              {description}
            </span>
          </div>
        </div>
      </div>
      <AnimatedWrapper className="relative z-10">
        <CodeSnippet apisToDisplay={path as AllowedApis} />
      </AnimatedWrapper>
    </section>
  );
}
